import React, {useEffect, useRef, useState} from 'react';
import './SearchNavbar.scss';
import {t} from 'react-switch-lang';
import DropdownContainer from '../dropdown/DropdownContainer';
import {getAllRisks} from '../../services/searchNavbar';
import Swal from 'sweetalert2';
import SelectList from '../select/SelectList';
import {FormProvider, useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import {getRevision, getRevisionByReferenceNumber} from '../../services/revisions';
import {useUserContext} from '../../contexts/UserContext';
import * as yup from 'yup';
import roles from '../../utils/roles';
import {courtRiskId, incurredRiskId, potentialRiskId} from "../../utils/const";

const SearchNavbar = (showSearchBar) => {
  const [search, setSearch] = useState('');
  const [isSearching, setIsSearching] = useState(0);
  const [revisionSearch, setRevisionSearch] = useState(false);

  const user = useUserContext();
  const userContext = useUserContext();
  const [schema, setSchema] = useState(
    yup.object().shape({
      selectOption: yup.object().required(t('message.fieldRequired')).nullable(),
    }),
  );
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      selectOption: {label:t('navbar.riskId'), value: 'riskId'}
    },

  });
  const {handleSubmit, watch} = methods;
  const riskSearch = !userContext.authorities.includes('ROLE_ADMIN');
  const revisionRoles = [
    roles.role_internal_auditor,
    roles.role_head_of_internal_audit,
    roles.role_super_admin,
    roles.role_internal_audit_responsible,
    roles.role_sector_director
  ];
  useEffect(() => {
    const result = revisionRoles.filter((element) =>
      user?.authorities?.includes(element)
    );
    setRevisionSearch(result.length > 0);
  }, [user]);

  const searchFocus = useRef(null);

  const onSearch = (e) => {
    e.preventDefault();
    (riskSearch && revisionSearch)
      ? (watch('selectOption')?.value === 'riskId' ?
          (setRedirectToRisk(search))
          :
          (setRedirectToRevision(search)))
      : (riskSearch ? setRedirectToRisk(search) : setRedirectToRevision(search));
    setIsSearching(isSearching + 1);

  };

  useEffect(() => {
    (showSearchBar && searchFocus.current.focus());
  }, [showSearchBar]);


  const setRedirectToRisk = (id) => {
    if (id !== undefined) {
      const validId = RegExp(/^[0-9]*$/);
      if (validId.test(id)) {


        getAllRisks(id)
          .then((r) => {
            if (r.data.riskTypeId === potentialRiskId) {
              window.location.pathname = `potential-risk/${id}`;
            } else if (r.data.riskTypeId === incurredRiskId) {
              window.location.pathname = `incurred-risk/${id}`;
            } else if (r.data.riskTypeId === courtRiskId) {
              window.location.pathname = `court-risk/${id}`;
            }

          }).catch(r => {
          if (r.response.status === 403) {
            Swal.fire({
              text: `${t('message.notAllowed')}`,
              icon: 'error',
              confirmButtonText: 'OK',
            });
          } else if (r.response.status === 500) {
            Swal.fire({
              text: `${t('message.idNotExists')}`,
              icon: 'error',
              confirmButtonText: 'OK',
            });
          }

        });
      } else {
        window.location = '/404';
      }
    } else {
      Swal.fire({
        text: `${t('message.errorId')}`,
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  };
  const setRedirectToRevision = (id) => {
    if (id !== undefined) {
      const validId = RegExp(/^[a-zA-Z0-9]*$/);
      if (validId.test(id)) {
        getRevisionByReferenceNumber(id)
          .then((r) => {
            const idRevision = r?.data?.content?.map(r=> r?.id)
            idRevision && (window.location.pathname = `revisions/${idRevision}`)

          }).catch(r => {
          if (r.response.status === 403) {
            Swal.fire({
              text: `${t('message.notAllowed')}`,
              icon: 'error',
              confirmButtonText: 'OK',
            });
          } else if (r.response.status === 500) {
            Swal.fire({
              text: `${t('message.revisionIdNotExists')}`,
              icon: 'error',
              confirmButtonText: 'OK',
            });
          }

        });
      } else {
        window.location = '/404';
      }
    } else {
      Swal.fire({
        text: `${t('message.errorId')}`,
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  };

  return (
    <DropdownContainer className='w-100' disableState={() => setIsSearching(0)}>
      <div
        className={`input-search-container arrow-hide`}
      ><FormProvider {...methods}>

        <form onSubmit={handleSubmit(onSearch)}>
          <button
            className='span-element'
            onClick={(e) => onSearch(e)}
          > </button>
          <input
            type='text'
            placeholder={ watch("selectOption")?.value === 'riskId' ? `${t('navbar.searchInput')}` : `${t('navbar.searchInputByRevision')}`}
            className='searchNavbar p-3'
            onChange={(e) => {
              setSearch(e.target.value);
            }}
            ref={searchFocus}
          />
          {revisionSearch && riskSearch &&
            <SelectList
              name='selectOption'
              className='select selectList'
              placeholder={t('revisions.placeholder.riskLevel')}
              options={[
                {
                  label: t('navbar.riskId'),
                  value: 'riskId',
                },
                {
                  label: t('navbar.revisionId'),
                  value: 'revisionId',
                },
              ]
              }
              isClearable={false}
            />}
        </form>
      </FormProvider>
      </div>
    </DropdownContainer>
  );
};

export default SearchNavbar;
